import { useState, useEffect } from "react";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle.tsx";
import { FormGroup, Input, Table, Button, Row, Col } from "reactstrap";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { IMember } from "../../../interfaces/IMember.tsx";
import { FillingBottle } from "react-cssfx-loading";
import BigText from "../../Text/BigText/BigText";
import { FaPen } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification";

import "./pocketnaro.css";

import React from "react";
function Pocketnaro() {
  const {
    updateIdsTaskMembers,
    updateMemberToTrelloId,
    updateListToStatus,
    testPartnerEmail,
    getInertiaNotifications,
    updateAllVersions
  } = useApiRequests();
  const { notify } = useNotification();

  const handleUpdateIds = async () => {
    try {
      const data = await updateIdsTaskMembers();
      if (data.success) {
        notify("Atualizado", { type: "success" });
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleUpdateMemberToTrelloId = async () => {
    try {
      const data = await updateMemberToTrelloId();
      if (data.success) {
        notify("Atualizado", { type: "success" });
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handlePartnerTest = async () => {
    const data = await testPartnerEmail();
    console.log(data);
  };

  const handleInertiaNotification = async () => {
    const data = await getInertiaNotifications();
    console.log("data", data);
  };

  const handleUpdateVersions = async () => {
    const data = await updateAllVersions();
    console.log("data", data);
  };

  return (
    <div className="buttons-container d-flex flex-column gap-5 w-50">
      <Button onClick={() => handleUpdateIds()}>
        Atualizar id dos membros nas tarefas
      </Button>
      <Button onClick={() => handleUpdateMemberToTrelloId()}>
        Atualizar o trelloId dos Membros para o UserID
      </Button>
      <Button onClick={() => updateListToStatus()}>
        Atualizar listas para status ( Nomes precisam ser iguais )
      </Button>
      <Button onClick={() => handlePartnerTest()}>Testar API Partner</Button>

      <Button onClick={() => handleUpdateVersions()}>
        Atualizar Versões
      </Button>

      <Row>
        <Col md={4}>
          <Button onClick={handleInertiaNotification} >Pegar dados do BOT de inércia</Button>
        </Col>
      </Row>
    </div>
  );
}

export default Pocketnaro;
